import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "audience-manager-header"
};
const _hoisted_2 = { class: "audience-manager-header__fields" };
const _hoisted_3 = { class: "audience-manager-header__inputs" };
const _hoisted_4 = { class: "audience-manager-header__name" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "*", -1);
const _hoisted_6 = ["readonly", "placeholder"];
const _hoisted_7 = {
    key: 0,
    class: "audience-manager-header__menu__id"
};
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import AudienceHeaderSkeleton from '@/features/AudienceManager/components/AudienceHeaderSkeleton.vue';
import AudienceCompositionSkeleton from '@/features/AudienceManager/components/Stages/Composition/AudienceCompositionSkeleton.vue';
import router from '@/router';
import { hasInvalidSpecialCharacters } from '@/utilities/validators/verifySpecialCharacters';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceHeader',
    setup(__props) {
        const store = useStore();
        const isViewMode = computed(() => store.getters['audienceManager/isView']);
        const steps = computed(() => store.getters['audienceManager/steps']);
        const isLoadingCompositionStage = computed(() => store.getters['audienceManager/isLoadingCompositionStage']);
        const hasErrorAudienceName = computed(() => store.getters['audienceManager/hasErrorAudienceName'] &&
            !store.getters['audienceManager/getAudienceName'].trim().length);
        const hasNoAudienceData = computed(() => store.getters['audienceManager/hasNoAudienceData']);
        const hasRouteQuery = computed(() => router.currentRoute.value?.query);
        const isCreationMode = computed(() => !isViewMode.value);
        const activeStep = computed({
            get: () => store.getters['audienceManager/activeStep'],
            set: value => changeStep(value),
        });
        const audienceName = ref(store.getters['audienceManager/getAudienceName']);
        const hasSpecialCharacters = ref(false);
        const verifySpecialCharacters = (name) => {
            const hasError = hasInvalidSpecialCharacters(name);
            if (hasError) {
                hasSpecialCharacters.value = true;
            }
            else {
                hasSpecialCharacters.value = false;
            }
        };
        const onAudienceNameInput = (event) => {
            const target = event.target;
            verifySpecialCharacters(target.value);
            if (!String(audienceName.value).trim().length) {
                setErrorAudienceName(true);
            }
            else {
                setErrorAudienceName(false);
            }
            store.commit('audienceManager/SET_AUDIENCE_NAME', audienceName.value);
        };
        const changeStep = (step) => {
            if (isStepDisabled(step) && !hasRouteQuery.value)
                return;
            store.dispatch('audienceManager/changeStep', step);
        };
        const isStepDisabled = (stepId) => {
            return stepId === 2 && isCreationMode.value && hasNoAudienceData.value;
        };
        const setErrorAudienceName = (value) => {
            store.commit('audienceManager/SET_ERROR_AUDIENCE_NAME', value);
        };
        watch(() => store.getters['audienceManager/getAudienceName'], newVal => {
            if (newVal !== audienceName.value) {
                audienceName.value = newVal;
            }
        });
        onMounted(() => {
            if (hasRouteQuery.value && hasRouteQuery.value.step === 'integrations') {
                changeStep(2);
            }
        });
        return (_ctx, _cache) => {
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_tab_pane = _resolveComponent("el-tab-pane");
            const _component_el_tabs = _resolveComponent("el-tabs");
            const _directive_focus = _resolveDirective("focus");
            return (!isLoadingCompositionStage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_el_tooltip, {
                                    visible: hasErrorAudienceName.value && !hasSpecialCharacters.value,
                                    "raw-content": true,
                                    content: _ctx.$t('campaigns.required-field'),
                                    placement: "right",
                                    "popper-class": "el--tooltip-error audience-manager-header--tooltip"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("label", null, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('audiences.name-label')) + " ", 1),
                                            _hoisted_5
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["visible", "content"]),
                                _createVNode(_component_el_tooltip, {
                                    visible: hasSpecialCharacters.value,
                                    "raw-content": true,
                                    content: _ctx.$t('audiences.error-characters-name'),
                                    placement: "right",
                                    "popper-class": "el--tooltip-error audience-manager-header--tooltip"
                                }, {
                                    default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((audienceName).value = $event)),
                                            type: "text",
                                            readonly: isViewMode.value,
                                            placeholder: _ctx.$t('audiences.define-name'),
                                            maxlength: "100",
                                            class: _normalizeClass({
                                                'audience-manager-header__name--error': hasErrorAudienceName.value || hasSpecialCharacters.value,
                                            }),
                                            onInput: onAudienceNameInput
                                        }, null, 42, _hoisted_6), [
                                            [_vModelText, audienceName.value],
                                            [_directive_focus]
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["visible", "content"])
                            ])
                        ])
                    ]),
                    _createVNode(_component_el_tabs, {
                        modelValue: activeStep.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((activeStep).value = $event)),
                        class: "audience-manager-header__menu",
                        onTabChange: changeStep
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step) => {
                                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                                    key: step.id,
                                    name: step.id,
                                    disabled: isStepDisabled(step.id)
                                }, {
                                    label: _withCtx(() => [
                                        _createElementVNode("span", null, [
                                            (!isViewMode.value)
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_7, _toDisplayString(step.id), 1))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(step.name)), 1)
                                        ])
                                    ]),
                                    default: _withCtx(() => [
                                        _renderSlot(_ctx.$slots, `step-${step.id}`)
                                    ]),
                                    _: 2
                                }, 1032, ["name", "disabled"]));
                            }), 128))
                        ]),
                        _: 3
                    }, 8, ["modelValue"])
                ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(AudienceHeaderSkeleton),
                    _createVNode(AudienceCompositionSkeleton)
                ], 64));
        };
    }
});
